(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .controller('TituloElectronicoAngController', TituloElectronicoAngController);

    TituloElectronicoAngController.$inject = ['TituloElectronico'];

    function TituloElectronicoAngController(TituloElectronico) {

        var vm = this;

        vm.tituloElectronicos = [];

        loadAll();

        function loadAll() {
            TituloElectronico.query(function(result) {
                vm.tituloElectronicos = result;
                vm.searchQuery = null;
            });
        }
    }
})();
